import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

import rootReducer from 'us_full_feature_pcb/rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['cart/doAddToCart/fulfilled'],
        ignoredPaths: ['payload.0.headers'],
      },
    }),
  ],
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
